import { render } from "./target_vs_achievement.vue?vue&type=template&id=55854309&scoped=true"
import script from "./target_vs_achievement.vue?vue&type=script&lang=js"
export * from "./target_vs_achievement.vue?vue&type=script&lang=js"

import "./target_vs_achievement.vue?vue&type=style&index=0&id=55854309&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55854309"]])

export default __exports__